// ===========================================
// useStudentView Hook
// ===========================================
// Hook to access student view context

import { useContext } from 'react';
import { StudentViewContext } from './StudentViewContext.types';

export function useStudentView() {
  const context = useContext(StudentViewContext);
  if (context === undefined) {
    throw new Error('useStudentView must be used within a StudentViewProvider');
  }
  return context;
}
